/**
 * Which actions the manifest review dialog offers, kept apart from the dialog
 * so the rules can be tested without standing up the whole screen.
 */

/**
 * Whether to offer Detach data and Delete document.
 *
 * Both run `deleteDocumentManifest`, which is staff-gated on the server. The
 * dialog itself is customer-facing now, so offering these to everyone would put
 * two actions in front of a customer that can only fail — and they read as
 * destructive, which makes a refusal worse than a missing menu.
 */
export function canOfferDestructiveReviewActions({
  documentLoaded,
  isStaff,
}: {
  /** A document is open and its manifest data has finished loading. */
  documentLoaded: boolean;
  isStaff: boolean;
}): boolean {
  return documentLoaded && isStaff;
}
